(() => {
  const initialize = (notifications) => {
    const element = notifications.element;

    element.querySelector('.notifications__items').classList.add('notifications__items--hidden');

    function toggleNotifications(event) {
      event.preventDefault();

      this.classList.toggle('notifications__toggle--hidden');

      element.classList.toggle('notifications--hidden');

      element.querySelector('.notifications__items').classList.toggle('notifications__items--hidden');
    }

    element.querySelector('.notifications__toggle').addEventListener('click', toggleNotifications);
  };

  const notifications = stp.setup('notifications');
  notifications.map(initialize);
})();
